import WorkingCategoryMap from '@/config/WorkingCategory.json';

const workingCategoryMap:any = {};
export default ():{} => {
    WorkingCategoryMap.forEach((i:{value:string; text:string;}) => {
        workingCategoryMap[i.value] = i.text;
    });
    return workingCategoryMap;
}